export default __webpack_public_path__ + "7c5fbe82587456655c9cc8b7d050b72f.png";